import { cleanUpStripeErrors } from '../data/actions';
import { expandViewForStripe, PAYMENT_MODAL_HIDE } from './actions';

const navigationMiddleware = () => {
	return function (next) {
		return function (action) {
			if (action.type === PAYMENT_MODAL_HIDE) {
				next(cleanUpStripeErrors(true));
				next(expandViewForStripe(true));

				return next(action);
			} else return next(action);
		};
	};
};

export default navigationMiddleware;